import { type Common } from './common.js';
import { type Availability, type CreateValues, type UpdateValues } from './models/availability.js';

export class API {
  common: Common;
  readonly baseEndpoint = '/availabilities';

  constructor(common: Common) {
    this.common = common;
  }

  async create(values: CreateValues): Promise<Availability> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async findOneById(id: string): Promise<Availability> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async update(id: string, values: UpdateValues): Promise<Availability> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    await this.common.deleteJSON(url);
  }
}
